export default __webpack_public_path__ + "static/media/wild-swim.905ac9e0.svg";